import React, { useEffect } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as validationService from "../add-device-modal/validationService";

function ApiUsernameField({ value, onChange, anotherSectionActive, passwordChanged, error, disabled }) {

    // useEffect(() => {
    //     validationService.validateNotEmpty(value, 'apiUsername');
    //     return () => validationService.cleanValidation('apiUsername');
    // }, [value])

    useEffect(() => {
        if (anotherSectionActive) {
            validationService.cleanValidation('apiUsername');
        } else {
            validationService.validateNotEmpty(value, 'apiUsername');
        }
        return () => validationService.cleanValidation('apiUsername');
    }, [value, anotherSectionActive])

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="apiusername">Username <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="apiusername"
                    type="text"
                    value={value}
                    disabled={!passwordChanged}
                    onChange={disabled ? null : event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("ApUsernameField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.apiUsername
    }
}

// function mapStateToProps(state) {
//     debug("ApiUsernameField mapStateToProps", state);
//     const addDeviceModal = state.addDeviceModal;
//     const validation = state.validation;
//     const anotherSectionActive = !!addDeviceModal.apiKey || !!addDeviceModal.apiUrl;
//     return {
//         apiUsername: addDeviceModal.apiUsername || '',
//         error: validation.apiUsername,
//         anotherSectionActive
//     }
// }

export default connect(mapStateToProps)(ApiUsernameField);
